import React from "react";
import {
    Box,
    Chip,
    FormControl,
    FormHelperText,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
} from "@mui/material";

const Remote = ({ value, setValue, error, setError }) => {
    const minLengthChecker = (currentValue) => {
        if (currentValue.length < 1) return `Should select an option`;
        return undefined;
    };

    const getCurrentValue = (event) => {
        const currentValue = event.target.value;
        return typeof currentValue === "string" ? currentValue.split(",") : currentValue;
    };

    const handleChange = (event) => {
        const selectedValues = getCurrentValue(event);
        const newValue = value.map((v) => ({
            ...v,
            selected: selectedValues.includes(v.title),
        }));
        setValue(newValue);
    };

    const handleBlur = (event) => {
        const selectedValues = getCurrentValue(event);
        const currentError = minLengthChecker(selectedValues);
        if (currentError) {
            setError(currentError);
        } else {
            setError(null);
        }
    };

    const options = value.map((v) => v.title);

    return (
        <FormControl fullWidth error={!!error}>
            <InputLabel id="demo-multiple-chip-label">Work Preferences</InputLabel>
            <Select
                fullWidth
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                value={value.reduce((acc, v) => {
                    if (v.selected) return [...acc, v.title];
                    return acc;
                }, [])}
                onChange={handleChange}
                onBlur={handleBlur}
                input={<OutlinedInput id="select-multiple-chip" label="Work Preferences" />}
                renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                        {selected.map((selectedItem) => (
                            <Chip key={selectedItem} label={selectedItem} />
                        ))}
                    </Box>
                )}
            >
                {options.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText error>{error || " "}</FormHelperText>
        </FormControl>
    );
};

export default Remote;
